module.exports = __webpack_public_path__ + "static/media/mgs2018logo.5bdf3917.svg";


//////////////////
// WEBPACK FOOTER
// ./src/mgs2018logo.svg
// module id = 375
// module chunks = 0